import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select, put, takeEvery } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile } from 'redux/saga/entities/bound';
import { memberStatus } from 'enums/memberStatus';
import { registerBanner } from 'features/Banners/BannerHost';
import { ReferAFriendBanner } from 'components/Banner/ReferAFriendBanner';
import { extractRafRewards } from 'components/Friendbuy/FriendbuyWidget';
import { addAnnouncement } from 'features/Banners/Banners.reducer';
import { DAY_MS } from 'constants/time-and-date';

const REFER_A_FRIEND_EXPIRATION_DAYS = 5;

export const SHOW_REFER_A_FRIEND_BANNER = 'SHOW_REFER_A_FRIEND_BANNER';
export const showReferAFriendBanner = banner => ({ type: SHOW_REFER_A_FRIEND_BANNER, banner });

export function* doShowReferAFriendBanner(client) {
  if (__SERVER__ && !__TEST__) {
    return;
  }

  if (!(yield select(isLoggedIn))) {
    return;
  }

  const user = yield call(fetchEntityIfNeeded, userProfile, [client]);
  const isActiveUser = memberStatus('ACTIVE', user && user.membership.status);
  const { rafSenderReward } = yield call(extractRafRewards, user);

  if (isActiveUser && rafSenderReward) {
    yield call(registerBanner, 'RAFBanner', ReferAFriendBanner);
    yield put(
      addAnnouncement(
        'RAFBanner',
        'RAFBanner',
        {
          rafSenderReward,
        },
        {
          suppressible: DAY_MS * REFER_A_FRIEND_EXPIRATION_DAYS,
        }
      )
    );
  }
}

export function* watchReferAFriendBanner(client) {
  yield takeEvery(SHOW_REFER_A_FRIEND_BANNER, doShowReferAFriendBanner, client);
}
